import { Navigate, Route, Routes } from "react-router-dom";
import { Shield } from "lucide-react";
import { AppFooter } from "@athavita/ui-theme";
import { HomePage } from "@/features/home/HomePage";
import { LoginPage } from "@/features/auth/LoginPage";
import { DeviceVerifyPage } from "@/features/auth/DeviceVerifyPage";
import { SignUpPage } from "@/features/auth/SignUpPage";
import { LogoutPage } from "@/features/auth/LogoutPage";
import { ChangePasswordPage } from "@/features/auth/ChangePasswordPage";
import { ProfilePage } from "@/features/auth/ProfilePage";
import { SecurityPage } from "@/features/auth/SecurityPage";

function AuthLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex min-h-screen flex-col bg-muted/40">
            <header className="flex h-12 shrink-0 items-center gap-2 bg-primary px-4 text-primary-foreground">
                <Shield className="h-5 w-5" aria-hidden />
                <span className="font-semibold">Athavita</span>
            </header>
            <main className="flex flex-1 items-center justify-center px-4 py-10">
                <div className="flex w-full max-w-xl justify-center">{children}</div>
            </main>
            <AppFooter />
        </div>
    );
}

export function App() {
    return (
        <AuthLayout>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/device" element={<DeviceVerifyPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/security" element={<SecurityPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </AuthLayout>
    );
}
